module.exports = __webpack_public_path__ + "static/4-79b929bb7ef2c291ef3e7f5bf5662deb.jpg";